import { render, staticRenderFns } from "./LoanPerformanceUpload.vue?vue&type=template&id=2bc0ff8a&"
import script from "./LoanPerformanceUpload.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports